import {Grid, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import "../../assets/css/competition.scss";
import Title from "../ReusableComponents/title";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import countryCodes from "../../utilities/countriesData";

const CompDetForm = (props) => {
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");
  const [Show, setShow] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");

  const myCountryNumberCodes = countryCodes;

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [contryCodeArray, setContryCodeArray] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [country, setCountry] = useState("");

  useEffect(() => {
    setContryCodeArray([]);
    var countV = Object.keys(myCountryNumberCodes).length;
    Object.entries(myCountryNumberCodes).map((item, index) => {
      let datamap = {
        countryName: item[0],
        countryCode: item[1],
      };
      setContryCodeArray((oldArray) => [...oldArray, datamap]);
    });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    if (FullName && Password) {
      const data = {
        pwd: Password,
        pwdInvestor: InvPassword,
        name: FullName,
        // email: Email,
        contact_number: selectedCountryCode + phoneNumber,
        apt_no: AptNo,
        street_address: Street,
        state: State,
        zip_code: Zip,
        country: country,
        ...(CommunityPass && { competition_password: CommunityPass }),
      };
      // console.log(data, 'dataaaaa')
      props.onSubmitChange(e, data);
    } else {
      setShowPopup(true);
      setCombinedPUHead("Oh snap!");
      setCombinedPUBody("Full name, email and contact number is mandatory");
      setPopUpType("error");
    }
  };

  const [FullName, setFullName] = useState();
  const handleFullName = (e) => {
    setFullName(e.target.value);
  };

  const [Email, setEmail] = useState();
  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const [Password, setPassword] = useState();
  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const [CommunityPass, setCommunityPass] = useState();
  const handleCommunityPass = (e) => {
    setCommunityPass(e.target.value);
  };

  const [InvPassword, setInvPassword] = useState();

  const [AptNo, setAptNo] = useState();

  const [Street, setStreet] = useState();

  const [State, setState] = useState();

  const [Zip, setZip] = useState();

  const handleCross = () => {
    setShow(false);
  };
  return (
    <Grid container item lg={8} sm={12}>
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        setShow={setShow}
        onClick={handleCross}
      />
      <Grid item container>
        <form
          style={{
            width: "100%",
            border: "1px solid #8B8E93",
            borderRadius: "12px",
            height: "fit-content",
          }}
        >
          <Grid container item spacing={2} style={{padding: "1rem"}}>
            <Grid item lg={6} sm={12} style={{width: "100%"}}>
              <Title three>Full Name</Title>
              <TextField
                fullWidth
                id="fullName"
                name="fullName"
                // className="form-input-text"
                value={FullName}
                onChange={handleFullName}
              />
            </Grid>
            {/* <Grid item lg={6} sm={12} style={{width: "100%"}}>
              <Title three>Email</Title>
              <TextField
                fullWidth
                type="email"
                value={Email}
                onChange={handleEmail}
              />
            </Grid> */}
            <Grid item lg={6} sm={12} style={{width: "100%"}}>
              <Title three>Master Password</Title>
              <TextField
                fullWidth
                value={Password}
                onChange={handlePassword}
                type="password"
              />
            </Grid>
            {props.isCommunity ? (
              <Grid item lg={6} sm={12} style={{width: "100%"}}>
                <Title three>Community Password</Title>
                <TextField
                  fullWidth
                  value={CommunityPass}
                  onChange={handleCommunityPass}
                  type="password"
                  required
                />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
          <button
            className="Button"
            onClick={(e) => onSubmit(e)}
            style={{maxWidth: "390px", width: "100%", marginBottom: "1rem"}}
          >
            Submit
          </button>
        </form>
      </Grid>
    </Grid>
  );
};

export default CompDetForm;
